export function Pumpkin({ className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden data-testid="halloween-pumpkin">
      <path d="M33 10c0-4 3-6 6-6" stroke="#4d7c0f" strokeWidth="4" fill="none" strokeLinecap="round" />
      <ellipse cx="20" cy="37" rx="14" ry="20" fill="#ea580c" />
      <ellipse cx="44" cy="37" rx="14" ry="20" fill="#ea580c" />
      <ellipse cx="32" cy="37" rx="14" ry="22" fill="#f97316" />
      <path d="M20 30l6 6h-9zM44 30l-6 6h9z" fill="#1c0a00" />
      <path d="M18 44q14 12 28 0l-4 1-3 4-3-4-4 4-3-4-3 4-3-4z" fill="#1c0a00" />
      <ellipse cx="32" cy="37" rx="14" ry="22" fill="url(#pg)" opacity=".35" />
      <defs>
        <radialGradient id="pg" cx=".35" cy=".3" r=".7">
          <stop offset="0" stopColor="#fff7ed" />
          <stop offset="1" stopColor="#f97316" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}

function Spider({ className }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden>
      <g stroke="#0a0a0a" strokeWidth="2.2" fill="none" strokeLinecap="round">
        <path d="M14 18L4 10M14 21L2 20M14 24L4 32M16 26L9 37" />
        <path d="M26 18l10-8M26 21l12-1M26 24l10 8M24 26l7 11" />
      </g>
      <ellipse cx="20" cy="23" rx="7" ry="8" fill="#0a0a0a" stroke="#ff4500" strokeWidth=".8" />
      <circle cx="20" cy="14" r="4.5" fill="#0a0a0a" stroke="#ff4500" strokeWidth=".8" />
      <circle cx="18.3" cy="13.5" r="1" fill="#ff4500" />
      <circle cx="21.7" cy="13.5" r="1" fill="#ff4500" />
    </svg>
  );
}

export function HangingSpider({ side = "right", length = 34 }) {
  return (
    <div
      className={`spider-hang absolute top-0 ${side === "right" ? "right-6" : "left-6"} z-20 pointer-events-none flex flex-col items-center`}
      style={{ animationDelay: `${(length % 7) * 0.2}s` }}
      aria-hidden
      data-testid="hanging-spider"
    >
      <div className="w-px bg-white/40" style={{ height: length }} />
      <Spider className="w-8 h-8 -mt-1 drop-shadow-[0_0_6px_rgba(255,69,0,0.6)]" />
    </div>
  );
}

function Bat({ className, style }) {
  return (
    <svg viewBox="0 0 64 32" className={className} style={style} aria-hidden>
      <path
        d="M32 10c-2-4-2-6 0-8 2 2 2 4 0 8 6-2 8 0 9 4 4-6 12-8 23-6-6 3-8 8-8 14-4-4-9-4-12 0-1-3-4-4-6-3-2 2-4 5-6 6-2-1-4-4-6-6-2-1-5 0-6 3-3-4-8-4-12 0 0-6-2-11-8-14 11-2 19 0 23 6 1-4 3-6 9-4z"
        fill="#0a0a0a"
        stroke="#ff4500"
        strokeOpacity=".35"
      />
    </svg>
  );
}

export function HalloweenBackdrop() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden data-testid="halloween-backdrop">
      <svg viewBox="0 0 200 200" className="absolute -top-2 -left-2 w-36 sm:w-56 opacity-25">
        <g stroke="#e5e5e5" strokeWidth=".8" fill="none">
          <path d="M0 0L200 60M0 0L140 140M0 0L60 200" />
          <path d="M40 12Q30 30 14 40M80 24Q60 60 28 80M120 36Q90 90 42 120M160 48Q120 120 56 160" />
        </g>
      </svg>
      <svg viewBox="0 0 200 200" className="absolute -top-2 -right-2 w-28 sm:w-44 opacity-20 -scale-x-100">
        <g stroke="#e5e5e5" strokeWidth=".8" fill="none">
          <path d="M0 0L200 60M0 0L140 140M0 0L60 200" />
          <path d="M40 12Q30 30 14 40M80 24Q60 60 28 80M120 36Q90 90 42 120" />
        </g>
      </svg>
      <Bat className="bat-fly absolute w-10 sm:w-14 top-[18%]" style={{ animationDuration: "19s" }} />
      <Bat className="bat-fly absolute w-7 sm:w-10 top-[42%]" style={{ animationDuration: "26s", animationDelay: "6s" }} />
      <Bat className="bat-fly absolute w-8 sm:w-12 top-[70%]" style={{ animationDuration: "31s", animationDelay: "12s" }} />
    </div>
  );
}
